/* shortcutDefs.jsx
provide destination shortcuts for quick-click filling out "path to insopec"
field in the Path Fetcher part of IARE.

This is so that common examples can be quickly entered with the click of a button
*/

// define array of shortcuts to use depending on environment
export const envShortcutLists = {
    prod: ['easterIsland', 'nuclear_war', 'mlk', 'internetArchive', 'pdfCovid',],  // production mode limited shortcuts
    stage: ['easterIsland', 'nuclear_war', 'mlk', 'internetArchive', 'grok_easter_island', 'short_test', ],  // staging shows a little more for testing
    other: ['easterIsland', 'easter_island_short', 'nuclear_war', 'mlk', 'internetArchive', 'grok_easter_island', 'grok_internet_archive', 'missMeyers', 'grok_island_local', 'assam', 'marc_bolan', 'kennewick_man', 'short_test'],  // everything else (my dev env, e.g.) shows lots more
}


export const ShortcutDefs = {

    "nuclear_war"  : {
        label : "Nuclear Warfare",
        value : "https://en.wikipedia.org/wiki/Nuclear_warfare"
    },

    "grok_easter_island"  : {
        label : "Grok: Easter Island",
        value : "https://grokipedia.com/page/Easter_Island"
    },

    "grok_internet_archive"  : {
        label : "Grok: Internet Archive",
        value : "https://grokipedia.com/page/Internet_Archive"
    },

    "grok_island_local"  : {
        label : "Grok: Easter Island - Local copy",
        value : "https://grokipedia.com/page/Easter_Island.crop",
        use_local_cache: true
    },

    "easter_island_short"  : {
        label : "Easter Island Short",
        value : "https://en.wikipedia.org/wiki/User:Iamojo/testcase/EasterIslandShort"
    },
    "hamas_israel"  : {
        label : "hamas_israel",
        value : "https://en.wikipedia.org/wiki/Israel–Hamas_war"
    },
    "mlk"  : {
        label : "MLK",
        value : "https://en.wikipedia.org/wiki/Martin_Luther_King_Jr."
    },
    "karen_bakker"  : {
        label : "Karen Bakker",
        value : "https://en.wikipedia.org/wiki/Karen_Bakker"
    },
    "short_test"  : {
        label : "Short Test",
        value : "https://en.wikipedia.org/wiki/User:Iamojo/iaritest/links"
    },
    "lindsay_lohan"  : {
        label : "Lindsay Lohan",
        value : "https://en.wikipedia.org/wiki/Lindsay_Lohan"
    },
    "easterIsland"  : {
        label : "Easter Island",
        value : "https://en.wikipedia.org/wiki/Easter_Island"
    },
    "internetArchive"  : {
        label : "Internet Archive",
        value : "https://en.wikipedia.org/wiki/Internet_Archive"
    },
    "assam" : {
        label: "Assam",
        value: "https://en.wikipedia.org/wiki/Assam"
    },


    "jamesWebb"  : {
        label : "James Webb Shortcut",
        value : "https://en.wikipedia.org/wiki/James_Webb_Space_Telescope"
    },
    "marc_bolan"  : {
        label : "Marc Bolan",
        value : "https://en.wikipedia.org/wiki/Marc_Bolan"
    },
    "kennewick_man"  : {
        label : "Kennewick Man",
        value : "https://en.wikipedia.org/wiki/Kennewick_Man"
    },


    "defaultFile"  : {
        label : "Easter Island Version 1",
        value : "http://18.217.22.248/v1/get-statistics?lang=en&site=wikipedia&title=Easter_Island"
    },
    "easterIslandV1"  : {
        label : "Easter Island Version 1",
        value : "http://18.217.22.248/v1/get-statistics?lang=en&site=wikipedia&title=Easter_Island"
    },
    "easterIsland2"  : {
        label : "Easter Island Wiki Stats",
        value : "https://archive.org/services/context/wari/v2/statistics/article?lang=en&site=wikipedia&title=Easter_Island",
    },
    "internetArchiveV1"  : {
        label : "Internet Archive Shortcut",
        value : "http://18.217.22.248/v1/get-statistics?lang=en&site=wikipedia&title=Internet_Archive"
    },
    "internetArchive2"  : {
        label : "Internet Archive Wiki Stats",
        value : "https://archive.org/services/context/wari/v2/statistics/article?lang=en&site=wikipedia&title=Internet_Archive"
    },

    "pdfCovid"  : {
        label : "Covid-19 PDF",
        value : "https://s3.documentcloud.org/documents/23782225/mwg-fdr-document-04-16-23-1.pdf"
    },
    "pdfOneLink"  : {
        label : "1 Link PDF",
        value : "https://www.foundationforfreedomonline.com/wp-content/uploads/2023/03/FFO-FLASH-REPORT-REV.pdf"
    },
    "pdfDesantis"  : {
        label : "DeSantis PDF",
        value : "https://ia601600.us.archive.org/31/items/Book_URLs/DeSantis.pdf"
    },
    "missMeyers"  : {
        label : "Miss Meyers",
        value : "https://en.wikipedia.org/wiki/Miss_Meyers"
    },



}
